import { render, staticRenderFns } from "./newsHeader.vue?vue&type=template&id=b8fd8aee&scoped=true&"
import script from "./newsHeader.vue?vue&type=script&lang=js&"
export * from "./newsHeader.vue?vue&type=script&lang=js&"
import style0 from "./newsHeader.vue?vue&type=style&index=0&id=b8fd8aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fd8aee",
  null
  
)

export default component.exports